import { createStyles } from "@material-ui/core";

export default createStyles({

  root: {

  },

  loaderContainer: {
    height: "100%",
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  loader: {

  },

  loaderText: {
    height: "100%",
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "50px"
  },
  
  content: {

  }

});